import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import _VaFileUploadSingleItem from './VaFileUploadSingleItem.vue'

export const VaFileUploadSingleItem = withConfigTransport(_VaFileUploadSingleItem)
